import { render, staticRenderFns } from "./SupportModal.vue?vue&type=template&id=4d5bda60"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"
import style0 from "./SupportModal.vue?vue&type=style&index=0&id=4d5bda60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports